import { Step, StepEngineStepGroup } from 'app/modules/step-engine/utils/step-engine-constants';
import { getKeyByValue } from 'app/modules/step-engine/utils/step-engine-methods';
import { stickyStepsMapper } from 'app/modules/sticky-recap/utils/sticky-mappers';
import { STEP_PREFIX } from 'app/shared/constants/constants';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Question from './components/question';
import './sticky-recap.scss';
import { checkEmptyObjectAttributes } from 'app/shared/util/method-util';
import { StepList } from 'app/modules/step-engine/service/store/step-engine-state';

interface IStickyRecapProps {
    questions?: any[];
}

const StickyRecap = (props: IStickyRecapProps) => {
    const { questions } = props || {};
    const { cmsContent } = useSelector((state: IRootState) => state.cms);
    const { declarationGlobalData, stepData, stepList } = useSelector((state: IRootState) => state.stepEngine);

    const showIndex = (stepName, insuredGroupIndex) => {
        if (declarationGlobalData === undefined)
            return true

        if (insuredGroupIndex !== null) { // step répétable
            if (declarationGlobalData.insuredGoods[insuredGroupIndex] === undefined)
                return true;
            if (declarationGlobalData.insuredGoods[insuredGroupIndex][stepName] === undefined)
                return true;
            if (declarationGlobalData.insuredGoods[insuredGroupIndex][stepName] === '')
                return true;
            if (!checkEmptyObjectAttributes(declarationGlobalData.insuredGoods[insuredGroupIndex][stepName]))
                return true;
        } else { // step non-répétable
            if (declarationGlobalData[stepName] === undefined)
                return true;
            if (declarationGlobalData[stepName] === '')
                return true;
            if (!checkEmptyObjectAttributes(declarationGlobalData[stepName]))
                return true;
        }
        return false;
    }

    const concatArrayElements = (array: string[]) => {
        let result = '';
        let index = 0;
        for (index = 0; index < array.length; index++) {
            if (index === 0)
                result = result.concat(array[index]["label"]);
            else
                if (index < 2)
                    result = result.concat(", " + array[index]["label"]);
        }
        if (array.length <= 2)
            return (
                <>
                    {result}
                </>
            )
        else
            return (
                <>
                    {result}
                    <div className='stickyResponseBadge'>
                        {
                            "+" + (array.length - 2).toString()
                        }
                    </div>
                </>
            )
    }

    const showResponse = (stepName, insuredGroupIndex) => {
        if (declarationGlobalData !== undefined) {
            if (declarationGlobalData[stepName] !== undefined) { // step non-répétable
                return stickyStepsMapper(getKeyByValue(Step, stepName), declarationGlobalData, cmsContent);
            } else if (declarationGlobalData.insuredGoods[insuredGroupIndex] && declarationGlobalData.insuredGoods[insuredGroupIndex][stepName]) { // step répétable
                return stickyStepsMapper(getKeyByValue(Step, stepName), declarationGlobalData, cmsContent, insuredGroupIndex);
            }
        }
        return "";
    };

    const focusStepToUpdate = (stepkey, insuredGroupIndex) => { // TODO: revoir, pour passer aussi l'index
        const elementToScroll: HTMLElement = document.getElementById(STEP_PREFIX + stepkey + (insuredGroupIndex != null ? insuredGroupIndex : ""));
        window.scrollTo({ top: elementToScroll.offsetTop, behavior: 'smooth' });
        elementToScroll.classList.toggle("hide-annimation", true);
        new Promise((resolve) => setTimeout(resolve, 1000))
            .then(res => {
                document.getElementById(STEP_PREFIX + stepkey + (insuredGroupIndex != null ? insuredGroupIndex : "")).classList.replace("hide-annimation", "show-annimation")
            })
    }

    // TODO: supprimer questions
    useEffect(() => {
        if (questions?.length > 1 && stepData.lastEditStep !== Step.DECLARATION_SUMMARY && stepData.currentStepGroup === StepEngineStepGroup.COVERAGE) {
            const elementToScroll: HTMLElement = document.getElementById(STEP_PREFIX + questions?.slice(-1)[0].component.props.dataKey + (questions?.slice(-1)[0].insuredGroupIndex != null ? questions?.slice(-1)[0].insuredGroupIndex : ""));
            const header: HTMLElement = document.getElementById("navBar_desktop");
            const footer: HTMLElement = document.getElementById("footer-container");
            const elementPosition = document.documentElement.scrollHeight - (header.offsetHeight * 2) - footer.offsetHeight - elementToScroll.offsetHeight;
            new Promise((resolve) => setTimeout(resolve, 100))
                .then(res => {
                    document.documentElement.style.scrollBehavior = "smooth";
                    window.scrollTo(0, elementPosition)
                })
        }
    }, [questions, stepData.lastEditStep])

    return (
        <div className="sticky-recap">
            <div className='sticky-container'>
                <div className='title'>
                    <div className="recap-title">
                        Déclaration de sinistre
                    </div>
                </div>
                <div className='questions'>
                    {stepList?.filter(s => cmsContent[Step[s.stepName]]?.behaviors?.hideFromRecap !== true && s.stepName !== stepList[0].stepName).map((step: StepList, key) => {
                        const stepName = Step[step.stepName];
                        return (
                            <React.Fragment key={key}>
                                <Question
                                    index={key}
                                    title={cmsContent[stepName]?.prismic?.gtmLabel}
                                    response={showResponse(stepName, step.insuredGroupIndex)}
                                    showIndex={showIndex(stepName, step.insuredGroupIndex)}
                                    focusStepToUpdate={() => focusStepToUpdate(stepName, step.insuredGroupIndex)}>
                                </Question>
                                <div className='question-line-separator' />
                            </React.Fragment>
                        );
                    })
                    }
                </div>
            </div>
        </div>
    );
};

export default StickyRecap;